// autogenerated by http://json2ts.com/ from https://regex101.com/r/Bw5fzt/2 of the server table json
// and then manually edited to reflect additional known types
export var CorporateActionMode;
(function (CorporateActionMode) {
    CorporateActionMode["big_div"] = "big_div";
    CorporateActionMode["splits_only"] = "splits_only";
    CorporateActionMode["total_returns"] = "total_returns";
    CorporateActionMode["raw"] = "raw";
})(CorporateActionMode || (CorporateActionMode = {}));
export var MarketSession;
(function (MarketSession) {
    MarketSession["premarket"] = "premarket";
    MarketSession["market"] = "market";
    MarketSession["aftermarket"] = "aftermarket";
    MarketSession["fullSession"] = "full_session";
    MarketSession["noPremarket"] = "no_premarket";
    MarketSession["noAftermarket"] = "no_aftermarket";
})(MarketSession || (MarketSession = {}));
//# sourceMappingURL=definition-models.js.map